import { Text } from './Text'
import { cn } from '@lib/cn'
import { ButtonHTMLAttributes, FC } from 'react'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant: 'primary' | 'secondary'
  children: string
}

export const Button: FC<ButtonProps> = ({ variant, className, children, ...rest }) => {
  const isPrimary = variant === 'primary'

  return (
    <button
      className={cn(
        'rounded-full border border-solid  transition-colors duration-150',
        isPrimary
          ? 'border-rolexPrimary bg-rolexPrimary text-white hover:bg-white hover:text-rolexPrimary'
          : 'border-rolexPrimary bg-white text-rolexPrimary hover:bg-rolexPrimary hover:text-white',
        'disabled:cursor-not-allowed disabled:border-rolexShade-200 disabled:bg-rolexShade-200 disabled:text-rolexShade-700',
        'flex h-auto w-auto items-center justify-center px-5 py-3',
        className,
      )}
      {...rest}
    >
      <Text variant="regular" className="leading-[1] text-inherit">
        {children}
      </Text>
    </button>
  )
}
